module.exports = "/_next/static/images/piggy-26f14d1c7dffcbdcbc410f42e1b41c19.png";